import request from "@/utils/request";
const Rms_host = process.env.VUE_APP_PHP_RMS_API_HOST;

export function allDataDownloadApi(params) {
  return request({
    // url: "?c=export&a=sensor-history&do=getall",
    url: `${Rms_host}?c=export&a=sensor-history&do=getall`,
    method: "get",
    params
  });
}

export function dataStatApi(params) {
  return request({
    // url: "?c=export&a=task&do=stat",
    url: `${Rms_host}?c=export&a=task&do=stat`,
    method: "get",
    params
  });
}

export function dataListApi(params) {
  return request({
    url: `${Rms_host}?c=export&a=task&do=list`,
    method: "get",
    params
  });
}

export function getDataApi(params) {
  return request({
    // url: "?c=export&a=task&do=get",
    url: `${Rms_host}?c=export&a=task&do=get`,
    method: "get",
    params
  });
}

export function downloadDataApi(params) {
  return request({
    // url: "?c=export&a=task&do=download",
    url: `${Rms_host}?c=export&a=task&do=fetch`,
    method: "get",
    params
  });
}

export function createDataApi(data) {
  return request({
    // url: "?c=export&a=sensor-history&do=getfew",
    url: `${Rms_host}?c=export&a=sensor-history&do=getfew`,
    method: "post",
    data
  });
}

export function deleteDataApi(data) {
  return request({
    // url: "?c=export&a=task&do=delete",
    url: `${Rms_host}?c=export&a=task&do=delete`,
    method: "post",
    data
  });
}

export function postPlanApi(data) {
  return request({
    // url: "?c=export&a=plan&do=post",
    url: `${Rms_host}?c=export&a=plan&do=post`,
    method: "post",
    data
  });
}

export function getPlanApi(params) {
  return request({
    // url: "?c=export&a=plan&do=get",
    url: `${Rms_host}?c=export&a=plan&do=get`,
    method: "get",
    params
  });
}

export function PlanListApi(params) {
  return request({
    // url: "?c=export&a=plan&do=list",
    url: `${Rms_host}?c=export&a=plan&do=list`,
    method: "get",
    params
  });
}

export function deletePlanApi(data) {
  return request({
    // url: "?c=export&a=plan&do=delete",
    url: `${Rms_host}?c=export&a=plan&do=delete`,
    method: "post",
    data
  });
}
